var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13 7.03821L9.52 2.83821C10.87 1.78821 13.12 1.73821 14.52 2.71821L20.7 7.04821C21.69 7.73821 22.5 9.28821 22.5 10.4982V17.7782C22.5 20.0882 20.61 21.9882 18.29 21.9882H6.71C4.39 21.9882 2.5 20.0882 2.5 17.7682V10.3582C2.5 9.22821 3.23 7.73821 4.13 7.03821ZM11.5 12C10.3954 12 9.5 12.8954 9.5 14V18C9.5 19.1046 10.3954 20 11.5 20H13.5C14.6046 20 15.5 19.1046 15.5 18V14C15.5 12.8954 14.6046 12 13.5 12H11.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeactive);
export default __webpack_public_path__ + "static/media/homeactive.80648e2d322c014feb9031f631816b02.svg";
export { ForwardRef as ReactComponent };